module.exports = __webpack_public_path__ + "officialStatic/img/sdt.e677ee5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/smartCampus/role/sdt.png
// module id = ih2W
// module chunks = 0